import { render, staticRenderFns } from "./LecturesTeacherEntityDetails.vue?vue&type=template&id=b59eccbc&scoped=true"
import script from "./LecturesTeacherEntityDetails.vue?vue&type=script&lang=js"
export * from "./LecturesTeacherEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LecturesTeacherEntityDetails.vue?vue&type=style&index=0&id=b59eccbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59eccbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b59eccbc')) {
      api.createRecord('b59eccbc', component.options)
    } else {
      api.reload('b59eccbc', component.options)
    }
    module.hot.accept("./LecturesTeacherEntityDetails.vue?vue&type=template&id=b59eccbc&scoped=true", function () {
      api.rerender('b59eccbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LecturesTeacherEntityDetails.vue"
export default component.exports